import { createContext, useState, useContext, useEffect } from "react";
import { json } from "react-router-dom";
import { API_BASE_URL } from "../Helpers/apiConfig";

const Context = createContext();


export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')) || false);


    const refreshUser = async () => {
        try {
            const current = JSON.parse(localStorage.getItem('user'));
            if (!current?.token) return;

            const res = await fetch(`${API_BASE_URL}/user/Opt/GetMe`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${current.token}`,
                },
            });

            if (!res.ok) return;

            const body = await res.json();
            if (!body.success) return;

            setUser((prev) => ({
                ...prev,
                user: body.data.user,
                userDetail: body.data.detail,
                educationals: body.data.educationals || [],
                educational: body.data.educational || null
            }));
        } catch (e) {
            console.log(e);
        }
    };
    const data = {
        user,
        setUser,
        refreshUser
    }
    useEffect(() => {
        localStorage.setItem('user', JSON.stringify(user))
    }, [user])
    return (
        <Context.Provider value={data}>
            {children}
        </Context.Provider>
    )
}
export const useAuth = () => useContext(Context)